import { render, staticRenderFns } from "./OrganisationPending.vue?vue&type=template&id=ba8bd084"
import script from "./OrganisationPending.vue?vue&type=script&lang=js"
export * from "./OrganisationPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports